import { api } from "@/api/client";
import { activeOwner, shellCache } from "@/offline/store";
import { getWorkspace } from "@/api/workspace";

export interface WorkspaceContext {
    signed_in: boolean;
    is_org_admin: boolean;
    org_type: string;
    is_owner_org: boolean;
    is_org_representative: boolean;
    org_name: string;
    can_switch_company: boolean;
    presence: "online" | "away" | "offline";
    can_manage_announcements: boolean;
    /** fingerprint of the installed server pack; a change means this app is stale */
    build: string;
}

export async function fetchWorkspaceContext(expected?: { userId: number; companyId: number }): Promise<WorkspaceContext> {
    if (!navigator.onLine) {
        const owner = await activeOwner();
        if (expected && (owner?.user_id !== expected.userId || owner.company_id !== expected.companyId)) {
            throw new Error("Offline identity changed");
        }
        const saved = owner?.workspace === getWorkspace() ? await shellCache<WorkspaceContext>("context") : undefined;
        if (saved) return { ...saved, presence: "offline" };
        if (owner?.workspace === getWorkspace()) return { signed_in: true, is_org_admin: false,
            org_type: "", is_owner_org: false, is_org_representative: false, org_name: owner.company_name,
            can_switch_company: false, presence: "offline", can_manage_announcements: false, build: "" };
        throw new Error("Offline workspace is not available");
    }
    return (await api.raw<WorkspaceContext>("/workspace/context")).data;
}
